import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService }                                   from '@ngx-translate/core';
import { UIRouter }                                           from '@uirouter/core';

import { AttachmentsService }             from './attachments.service';
import { AttachmentModel }                from './typings/attachment';
import { AttachmentOptionsModel }         from './typings/attachment.options';
import { AttachmentThumbnailStatusModel } from './typings/attachment.thumbnail-status';
import { MessagesService }                from '../messages/messages.service';

@Component({
  selector   : 'wor-attachments-box',
  template: require('./attachments.box.component.html')
})
export class AttachmentsBoxComponent implements OnChanges {
  @Input() attachments: Array<AttachmentModel> = [];
  @Input() options    : AttachmentOptionsModel;

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  file: File | null;

  isUploading = false;

  thumbnails: AttachmentThumbnailStatusModel = {
    isLoading    : true,
    isSuccessful : false,
    percentLoaded: 0
  };

  constructor (
    public  attachmentsService: AttachmentsService,
    private messagesService   : MessagesService,
    private router            : UIRouter,
    private translateService  : TranslateService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( this.options && this.options.open === undefined ) {
      this.options.open = true;
    }

    if ( changes.attachments && this.attachments ) {
      this.attachmentsService.getThumbnails(this.thumbnails, this.attachments)
      .catch(() => undefined);
    }
  }

  delete ( attachment : AttachmentModel ) : void {
    this.attachmentsService.deleteAttachment(attachment, this.options)
    .then(() => {
      this.router.stateService.reload();

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.DELETED'), 'success');
    })
    .catch(error => this.messagesService.error(error));
  }

  emailVideo ( attachment : AttachmentModel ) : void {
    this.attachmentsService.sendVideo(attachment, {
      contact: this.options.contact,
      method : 'email',
      table  : this.options.table
    })
    .then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  selectFile ( input : HTMLInputElement ) : void {
    this.file = input.files[ 0 ] || null;
  }

  showAttachment ( attachment : AttachmentModel ) : void {
    this.attachmentsService.showAttachment(attachment)
    .catch(error => this.messagesService.error(error));
  }

  smsVideo ( attachment : AttachmentModel ) : void {
    this.attachmentsService.sendVideo(attachment, {
      contact: this.options.contact,
      method : 'sms',
      table  : this.options.table
    })
    .then(() => this.messagesService.show(this.translateService.instant('GENERAL_SPACE.MESSAGE.SMS_SENT'), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  trackByAttachmentId ( _index : number, attachment : AttachmentModel ) : string {
    return attachment.id;
  }

  upload () : void {
    if ( !this.file || this.isUploading ) {
      return;
    }

    this.isUploading = true;

    this.attachmentsService.upload(this.file, this.options)
    .then(attachments => {
      this.file = null;

      this.fileInput.nativeElement.value = '';
      this.attachments.length            = 0;

      this.attachments.push(...attachments);

      return this.attachmentsService.getThumbnails(this.thumbnails, attachments);
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => {
      this.isUploading = false;
    });
  }
}
